import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RiChatSmileFill } from "react-icons/ri";
import { Doughnut } from 'react-chartjs-2';
import { Bar, Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';
import ModalComponent from "../pick_modal";
import axios from "axios";
import { toast } from "react-hot-toast";
import { BASELINE } from "../../../util";
import DashboardAI from "../AI_Chat/Dashboard_AI";
import { CiBoxList } from "react-icons/ci";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const DigitalNMSQTView = ({ setActiveIndex, user, lastTest, data2, options2, setdashboard, avg_sat, avg_eng, avg_math, Incorrect_questionIds, allSATScores }) => {
    const navigate = useNavigate();
    const [isVisible, setIsVisible] = useState(true);
    const topEngTopics = findTopMissedTopics(Incorrect_questionIds, "eng");
    const topMathTopics = findTopMissedTopics(Incorrect_questionIds, "math");
    const [topic, settopic] = useState(false);
    const [section, setsection] = useState("");
    const type = 'SAT10';
    const [isModalOpen2, setIsModalOpen2] = useState(false);

    const [lastscore, setlastscore] = useState(lastTest);
    const [averageMCQ, setAverageMCQ] = useState(avg_eng);
    const [averageFRQ, setAverageFRQ] = useState(avg_math);
    const [scorearr, setscorearr] = useState([]);

    const [analcomp, setanalcomp] = useState(1);

    const [esubjects, esetSubjects] = useState([
        {
            name: 'Information and Ideas', count: 0, isOpen: true, isSelected: false, tag: 'English',
            subTopics: [
                { name: 'Inferences', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
                { name: 'Central Ideas and Details', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
                { name: 'Command of Evidence', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
            ]
        },
        {
            name: 'Craft and Structure', count: 0, isOpen: true, isSelected: false, tag: 'English',
            subTopics: [
                { name: 'Words in Context', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
                { name: 'Text Structure and Purpose', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
                { name: 'Cross-Text Connections', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
            ]
        },
        {
            name: 'Expression of Ideas', count: 0, isOpen: true, isSelected: false, tag: 'English',
            subTopics: [
                { name: 'Rhetorical Synthesis', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
                { name: 'Transitions', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } }
            ]
        },
        {
            name: 'Standard English Conventions', count: 0, isOpen: true, isSelected: false, tag: 'English',
            subTopics: [
                { name: 'Boundaries', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
                { name: 'Form, Structure, and Sense', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } }
            ]
        }
    ]);

    const [msubjects, msetSubjects] = useState([
        {
            name: 'Algebra', count: 0, isOpen: true, isSelected: false, tag: 'Math',
            subTopics: [
                { name: 'Linear functions', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
                { name: 'Systems of two linear equations in two variables', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
                { name: 'Linear inequalities in one or two variables', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
                { name: 'Linear equations in one variable', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
            ]
        },
        {
            name: 'Advanced Math', count: 0, isOpen: true, isSelected: false, tag: 'Math',
            subTopics: [
                { name: 'Nonlinear functions', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
                { name: 'Equivalent expressions', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
            ]
        },
        {
            name: 'Problem-solving and Data Analysis', count: 0, isOpen: true, isSelected: false, tag: 'Math',
            subTopics: [
                { name: 'Ratios, rates, proportional relationships, and units', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
                { name: 'Probability and conditional probability', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
                { name: 'One-variable data: Distributions and measures of center and spread', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
                { name: 'Two-variable data: Models and scatterplots', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
                { name: 'Percentages', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
            ]
        },
        {
            name: 'Geometry and Trigonometry', count: 0, isOpen: true, isSelected: false, tag: 'Math',
            subTopics: [
                { name: 'Lines, angles, and triangles', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
                { name: 'Right triangles and trigonometry', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
                { name: 'Area and volume', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
            ]
        }
    ]);

    // Assuming mcqsubjects and frqsubjects are available in the scope
    const mcqIdToNameMap = {};
    esubjects.forEach(subject => {
        subject.subTopics.forEach((subtopic, index) => {
            mcqIdToNameMap[index] = subtopic.name;
        });
    });

    const frqIdToNameMap = {};
    msubjects.forEach(subject => {
        subject.subTopics.forEach((subtopic, index) => {
            frqIdToNameMap[index] = subtopic.name;
        });
    });

    const handleClose = () => {
        setIsVisible(false);
    };

    const handleRowClick = (subjectName, section) => {
        setsection(section);
        settopic(subjectName);
        setIsModalOpen2(true);
        // You can perform any actions here, such as navigation or displaying details
    };

    function findTopMissedTopics(data, tag) {
        const topicCount = {};

        // Count incorrect topics for the specified tag
        data.forEach(item => {
            if (item.tag === tag && !item.correct) {
                topicCount[item.topic] = (topicCount[item.topic] || 0) + 1;
            }
        });

        // Convert the topicCount object into an array of [topic, count] pairs
        const sortedTopics = Object.entries(topicCount).sort((a, b) => b[1] - a[1]);

        // Select the top 10
        return sortedTopics.slice(0, 10).map(entry => ({ topic: entry[0], count: entry[1] }));
    }

    function generateLabels(length) {
        return Array.from({ length }, (_, index) => `Test ${index + 1}`);
    }


    const data3 = {
        labels: generateLabels(allSATScores.length),  // Dynamic labels based on the number of scores
        datasets: [
            {
                label: 'NMSQT Score',
                data: allSATScores,
                fill: false,
                borderColor: 'rgba(51, 65, 85, 1)',
                tension: 0.1
            }
        ]
    };

    const data4 = {
        labels: [''],
        datasets: [
            {
                label: 'Max Score',
                data: [800],
                backgroundColor: 'rgba(201, 203, 207, 0.6)',
            },
            {
                label: 'English Score',
                data: [avg_eng],
                backgroundColor: 'rgba(51, 65, 85, 1)',
            },
            {
                label: 'Math Score',
                data: [avg_math],
                backgroundColor: 'rgba(22,30,45,255)',
            },
        ],
    };

    const options4 = {
        indexAxis: 'y',
        scales: {
            x: {
                max: 800,
                beginAtZero: true,
            },
        },
    };

    // Options for the line graph
    const options3 = {
        scales: {
            y: {
                beginAtZero: false,  // Change this as needed
                suggestedMax: 1600  // Assuming SAT scores are out of 1600
            }
        },
        maintainAspectRatio: false
    };

    const data = {
        datasets: [{
            data: [avg_sat, 1600 - avg_sat],
            backgroundColor: ['#334155', '#D0D0D0'],
            hoverBackgroundColor: ['#334155', '#D0D0D0'],
            borderWidth: 0,
        }],
        labels: ['Score', 'Remaining'],
    };


    return (
        <div className="bg-gray-100">
            <ModalComponent topic={topic} isOpen={isModalOpen2} onClose={setIsModalOpen2} section={section} type={type} />
            <div className="p-6 flex flex-col items-center">
                <div className="w-full max-w-[100%]">
                    <div className="mb-4 text-gray-500 text-sm">
                        <span className="hover:underline cursor-pointer">My Home</span> &gt; <span className="font-semibold text-black">Dashboard</span>
                    </div>
                    <h1 className="mb-[20px] text-2xl font-bold mt-4">Digital PSAT NMSQT View</h1>

                    {isVisible && (
                        <div className="p-6 bg-white border rounded-md">
                            <button
                                onClick={handleClose}
                                className="text-gray-600 hover:text-gray-800 ml-[99%]"
                            >
                                ✖
                            </button>
                            <div className="flex items-center space-x-4">
                                <div className="flex-shrink-0">
                                    <div className="bg-indigo-500 rounded-full p-4">
                                        <RiChatSmileFill className="text-white text-4xl" />
                                    </div>
                                </div>
                                {user && (
                                    <div>
                                        <div className="text-lg font-medium text-black">
                                            Welcome <span className="gradient-text font-bold">{user.first_name}</span> <span role="img" aria-label="wave">👋</span>
                                        </div>
                                        <div className="text-gray-500">{user.email}</div>
                                        <div className="mt-2 text-gray-600">
                                            Study hard and aim for a <span className="font-semibold text-black">1600 </span> on the <span className="text-red-500 font-semibold">NMSQT!</span> <span role="img" aria-label="gift">🎁</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div className="pl-6 pr-6 flex flex-col items-center">
                <div className="w-full">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="p-6 bg-gradient-to-br from-gray-800 to-gray-900 text-white shadow-md rounded-md flex flex-col justify-between">
                            <div>
                                <div className="flex items-center mb-4">
                                    <span className="bg-gray-700 text-white text-sm font-semibold mr-2 px-2.5 py-0.5 rounded border border-white">Digital NMSQT</span>
                                    <span className="text-lg font-medium">Your Latest NMSQT Score</span>
                                </div>

                                <div className="flex">
                                    <div className="text-5xl font-bold mb-4">{lastTest}</div>
                                    <div className="text-5xl mb-4 ml-4"> | 400-1600</div>
                                </div>

                                <span className="gradient-text">
                                    Check if you have an unfinished test. <br /> Complete the test to get your analytics report.
                                </span>
                            </div>
                            <div className="flex gap gap-2">
                                <button className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 rounded-md mb-2" onClick={() => { setdashboard(5); }}
                                >

                                    Continue the Test
                                </button>
                                <button className="w-full bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 rounded-md mb-2" onClick={() => { setdashboard(201); }}
                                >
                                    Get Help Session
                                </button>
                            </div>
                        </div>

                        <div className="p-6 bg-white shadow-md rounded-md">
                            <div className="h-full flex flex-col justify-center items-center">
                                <div className="w-full h-64 flex justify-center items-center">
                                    <Bar data={data2} options={options2} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-6 pl-6 pr-6 flex flex-col items-center">
                <div className="w-full flex gap-4" style={{ maxHeight: '330px' }}>
                    <div className="relative flex-3 p-4" style={{ flex: 3 }}>
                        <div className="absolute inset-0 border-1 rounded-xl border-transparent bg-gradient-to-r from-purple-400 to-blue-400 p-[2px]">
                            <div className="h-full w-full bg-white rounded-xl"></div>
                        </div>
                        <div className="relative">
                            <h2 className="text-lg font-semibold mb-2">Overall Average NMSQT Score</h2>
                            <div style={{ height: '180px' }}>  {/* Set a specific height for the graph container */}
                                <Doughnut
                                    data={data}
                                    options={{
                                        maintainAspectRatio: false, // This prevents the chart from inheriting aspect ratio
                                        aspectRatio: 1, // Sets the aspect ratio to 1:1 (you can adjust as needed)
                                    }}
                                />
                            </div>
                            <div className="text-center mt-2">
                                {avg_sat && (<>
                                    <span className="text-2xl font-bold">{avg_sat}</span> / 1600
                                </>)}
                            </div>
                        </div>
                    </div>

                    <div className="relative flex-3 p-4" style={{ flex: 7 }}>
                        <div className="absolute inset-0 border-1 rounded-xl border-transparent bg-gradient-to-r from-purple-400 to-blue-400 p-[2px]">
                            <div className="h-full w-full bg-white rounded-xl"></div>
                        </div>

                        <div className="relative">
                            <h2 className="text-lg font-semibold mb-2">Average English, Math Scores</h2>

                            <div className="h-full flex flex-col justify-center items-center">
                                <div className="w-full h-64 flex justify-center items-center">
                                    <Bar data={data4} options={options4} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-6 pl-6 pr-6 flex flex-col items-center">
                <div className="w-full">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="p-6 bg-gradient-to-br from-gray-800 to-gray-900 text-white shadow-md rounded-md flex flex-col justify-between">
                            <div>
                                <div className="flex items-center mb-4">
                                    <span className="bg-gray-700 text-white text-sm font-semibold mr-2 px-2.5 py-0.5 rounded border border-white">Digital NMSQT</span>
                                    <span className="text-xl font-bold">🏆Recomend English Missing Topics</span>
                                </div>
                                <div className="flex-7 p-4 rounded overflow-auto" style={{ maxHeight: '240px', overflowY: 'auto' }}>

                                    <ul className="list-disc pl-5">
                                        {topEngTopics.map((topic, index) => (
                                            <li
                                                key={index}
                                                className="mb-1 text-xl cursor-pointer hover:bg-gray-300"
                                                onClick={() => handleRowClick(topic.topic, "English")}
                                                style={{ transition: 'background-color 0.3s' }}

                                            >
                                                {topic.topic}: {topic.count}
                                            </li>
                                        ))}
                                    </ul>


                                </div>
                            </div>

                        </div>

                        <div className="p-6 bg-gradient-to-br from-gray-800 to-gray-900 text-white shadow-md rounded-md flex flex-col justify-between">
                            <div>
                                <div className="flex items-center mb-4">
                                    <span className="bg-gray-700 text-white text-sm font-semibold mr-2 px-2.5 py-0.5 rounded border border-white">Digital NMSQT</span>
                                    <span className="text-xl font-bold">🏆Recomend Math Missing Topics</span>
                                </div>

                                <div className="flex-7 p-4 rounded overflow-auto" style={{ maxHeight: '240px', overflowY: 'auto' }}>

                                    <ul className="list-disc pl-5">
                                        {topMathTopics.map((topic, index) => (
                                            <li
                                                key={index}
                                                className="mb-1 text-xl cursor-pointer hover:bg-gray-300"
                                                onClick={() => handleRowClick(topic.topic, "Math")}
                                                style={{ transition: 'background-color 0.3s' }}
                                            >
                                                {topic.topic}: {topic.count}
                                            </li>
                                        ))}
                                    </ul>


                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div className="relative flex-3 p-6 pr-6 pl-6 mr-6 ml-6 mb-[100px] rounded mt-6">
                <div className="absolute inset-0 border-1 rounded-xl border-transparent bg-gradient-to-r from-purple-400 to-blue-400 p-[2px]">
                    <div className="h-full w-full bg-white rounded-xl"></div>
                </div>

                <div className="relative">
                    <h2 className="text-lg font-semibold mb-2">Overall NMSQT Scores</h2>

                    <div className="h-full flex flex-col justify-center items-center">
                        <div className="w-full h-64 flex justify-center items-center">
                            <Line data={data3} options={options3} />
                        </div>
                    </div>
                </div>
            </div>

            <DashboardAI
                subject={"SAT10"}
                lastscore={lastscore}
                avg_sat={avg_sat}
                averageMCQ={averageMCQ}
                averageFRQ={averageFRQ}
                esubjects={esubjects}
                msubjects={msubjects}
                analcomp={analcomp}
            />

        </div>
    );
};

export default DigitalNMSQTView;
